import Styles from './Item.scss';

import Template from './Item.hbs';
import ContentLabel from 'views/components/contentLabel/ContentLabel.svelte'
import ProgressBar from 'views/components/progressBar/ProgressBar.svelte'
import WeekLabel from '../../../weekLabel/WeekLabel'

export default class Item extends BaseView {

    initialize({ contentUrl, hasProgress, progress, progressUrl }) {

        const showProgress = hasProgress && !ISMOBILE

        this.setElement(Template({
            Styles,
            contentUrl,
            progressUrl,
            hasProgress: showProgress,
            contentIcon: this.model.get('week') ? 'planner' : 'show'
        }))

        if (this.model.get('week')) {
            this.addChildView(
                new WeekLabel({
                    model: this.model
                }),
                this.$('.js-content-label')
            )
        } else {
            this.addSvelteChildView(this.$('.js-content-label'), ContentLabel, {
                model: this.model,
                truncateName: true,
                smallText: true,
            })
        }

        if (showProgress) {
            this.addSvelteChildView(this.$('.js-progress-bar'), ProgressBar, {
                fragments: {
                    blue: progress
                },
                showLabel: true,
                width: 40
            })
        }
    }

}
